import React from 'react'
import { flowRight } from 'lodash'
import { Trans, useTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { getBosEditPath } from 'lib/utils/store/bos'
import { getLocale } from 'lib/utils/getLocale'

import ErrorMessageContent from './ErrorMessageContent'

const DraftNotValidMessage = ({ match }) => {
    const { t, i18n } = useTranslation(['errors', 'common'])
    const bosId = match.params.bosId

    return (
        <ErrorMessageContent
            title={t('errorMessage.sessionExpired.title')}
            content={(
                <p>
                    <Trans i18nKey="errors:errorMessage.bosDraftNotValid.message">
                        Kauppakirja ei ole valmis, tai luonnosta on muokattu. Tarkasta kauppakirjan tiedot <a href={`${getLocale(i18n.language)}${getBosEditPath(bosId)}`}>muokkaus näkymästä</a> ja yritä uudelleen.
                    </Trans>
                </p>
            )}
        />
    )
}

export default flowRight(
    withRouter,
)(DraftNotValidMessage)
